import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import "./AcademicExperience.css";
import logo_tohoku from "../assets/logos/TohokuUniv.gif";
import logo_centrale from "../assets/logos/CentraleLyon.png";

const academicExperienceData = [
  {
    institution: "Tohoku University, Graduate School of Engineering",
    logo: logo_tohoku,
    role: "PhD Candidate in Communication Engineering",
    // description: "Conducting research on explainable artificial intelligence and robustness of deep learning models under the supervision of Prof. Shinichiro Omachi.",
    duration: "Apr. 2025 - Present",
    location: "Sendai, Japan",
    link: "https://www.eng.tohoku.ac.jp/english/academics/studies/graduate/communication.html",
    borderless: true,
  },
  {
    institution: "Tohoku University, Graduate School of Engineering",
    logo: logo_tohoku,
    role: "Master of Science in Communication Engineering (Double Degree)",
    // description: "Conducting research on explainable artificial intelligence and robustness of deep learning models under the supervision of Prof. Shinichiro Omachi.",
    duration: "Apr. 2023 - Mar. 2025",
    location: "Sendai, Japan",
    link: "https://www.eng.tohoku.ac.jp/english/academics/studies/graduate/communication.html",
    borderless: true,
  },
  {
    institution: "École Centrale de Lyon",
    logo: logo_centrale,
    role: "Master of Science in Engineering (Double Degree)",
    // description: "Conducting research on explainable artificial intelligence and robustness of deep learning models under the supervision of Prof. Shinichiro Omachi.",
    duration: "Sep. 2020 - Mar. 2025",
    location: "Lyon, France",
    link: "https://www.ec-lyon.fr/",
    borderless: true,
  },
];

const AcademicExperience = () => (
  <section id="academic-experience" className="academic-experience-section">
    <h2>Academic Experience</h2>
    {academicExperienceData.map((experience, index) => (
      <div key={index} className="academic-experience-card">
        <div
          className={`academic-logo ${
            experience.borderless ? "borderless" : ""
          }`}
        >
          <img src={experience.logo} alt={`${experience.institution} logo`} />
        </div>
        <div className="academic-details">
          <h4>
            {experience.institution}
            {experience.link && (
              <a
                href={experience.link}
                target="_blank"
                rel="noopener noreferrer"
                className="company-link"
                title={`Visit ${experience.institution}`}
              >
                <FaExternalLinkAlt />
              </a>
            )}
          </h4>
          <p className="academic-role">{experience.role}</p>
          <p className="academic-description">{experience.description}</p>
          <div className="academic-meta">
            <span className="academic-duration">{experience.duration}</span> |
            <span className="academic-location">{experience.location}</span>
          </div>
        </div>
      </div>
    ))}
  </section>
);

export default AcademicExperience;
